"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplashScreen = SplashScreen;
const React = __importStar(require("react"));
const ui_1 = require("@creature-chess/ui");
const classnames_1 = __importDefault(require("classnames"));
const useStyles_1 = require("~/useStyles");
const bootEntrance_1 = require("./menu/bootEntrance");
const LOGO_SRC = `${APP_IMAGE_ROOT}/ui/logo.png`;
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    "overlay": {
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Covers the app while booting/reconnecting; blocks clicks from reaching
        // the menu mounted behind it until the splash unmounts.
        pointerEvents: "auto",
    },
    "contentGameOut": {
        // Reconnecting into a game/lobby: the logo fades out first, while the
        // background still hides the game behind it.
        animation: `$bgFade ${bootEntrance_1.BOOT_LOGO_FADE_MS}ms ease forwards`,
    },
    "blueGameOut": {
        // ...then the background fades, revealing the game only once the logo's gone.
        animation: `$bgFade ${bootEntrance_1.BOOT_BG_FADE_MS}ms ease ${bootEntrance_1.BOOT_LOGO_FADE_MS}ms both`,
    },
    "blue": {
        position: "absolute",
        inset: 0,
        background: theme.palette.background,
    },
    "blueOut": {
        animation: `$bgFade ${bootEntrance_1.BOOT_BG_FADE_MS}ms ease forwards`,
    },
    "content": {
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2.5rem",
    },
    "contentOut": {
        // Waits for the background fade and the logo sheen, then fades out; the
        // menu fades in afterwards (see GameMenu).
        animation: `$bgFade ${bootEntrance_1.BOOT_LOGO_FADE_MS}ms ease ${bootEntrance_1.BOOT_LOGO_FADE_DELAY_MS}ms both`,
    },
    "logoWrap": {
        position: "relative",
        display: "inline-block",
        lineHeight: 0,
    },
    "logo": {
        display: "block",
        width: "min(60vw, 360px)",
        height: "auto",
        filter: "drop-shadow(0px 6px 6px rgba(0, 0, 0, 0.45))",
    },
    "sheen": {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        // Bright diagonal band, clipped to the logo's shape via the mask.
        background: "linear-gradient(115deg, transparent 40%, rgba(255, 255, 255, 0.85) 50%, transparent 60%)",
        backgroundSize: "300% 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "100% 0",
        WebkitMaskImage: `url(${LOGO_SRC})`,
        maskImage: `url(${LOGO_SRC})`,
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
    },
    "sheenAnim": {
        // Sweeps once, after the background fade, before the crossfade.
        animation: `$logoSheen ${bootEntrance_1.BOOT_SHEEN_MS}ms ease ${bootEntrance_1.BOOT_BG_FADE_MS}ms both`,
    },
    "spinnerOut": {
        animation: `$bgFade ${bootEntrance_1.BOOT_BG_FADE_MS}ms ease forwards`,
    },
    "footer": {
        position: "absolute",
        bottom: "1rem",
        left: 0,
        right: 0,
        zIndex: 1,
        textAlign: "center",
        fontFamily: theme.typography.primary,
        fontSize: "0.85rem",
        color: theme.palette.light.neutral,
    },
    "@keyframes bgFade": {
        from: { opacity: 1 },
        to: { opacity: 0 },
    },
    "@keyframes logoSheen": {
        from: { backgroundPosition: "100% 0" },
        to: { backgroundPosition: "0% 0" },
    },
}));
function SplashScreen({ entering, mode = "menu", }) {
    const classes = useStyles();
    // The menu choreography crossfades the logo into the menu; the game path has
    // no menu behind it, so the whole splash fades out as one.
    const menuEntering = entering && mode === "menu";
    const gameFade = entering && mode === "game";
    return (React.createElement("div", { className: classes.overlay },
        React.createElement("div", { className: (0, classnames_1.default)(classes.blue, {
                [classes.blueOut]: menuEntering,
                [classes.blueGameOut]: gameFade,
            }) }),
        React.createElement("div", { className: (0, classnames_1.default)(classes.content, {
                [classes.contentOut]: menuEntering,
                [classes.contentGameOut]: gameFade,
            }) },
            React.createElement("div", { className: classes.logoWrap },
                React.createElement("img", { className: classes.logo, src: LOGO_SRC, alt: "Creature Chess" }),
                React.createElement("div", { className: (0, classnames_1.default)(classes.sheen, {
                        [classes.sheenAnim]: menuEntering,
                    }) })),
            React.createElement("div", { className: (0, classnames_1.default)({ [classes.spinnerOut]: menuEntering }) },
                React.createElement(ui_1.Spinner, { size: 56 }))),
        React.createElement("div", { className: (0, classnames_1.default)(classes.footer, {
                [classes.blueOut]: menuEntering,
                [classes.contentGameOut]: gameFade,
            }) }, "\u00A9 Tiberisoft 2026")));
}
